var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintainenceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.43,
    height: 66.332,
    viewBox: "0 0 65.43 66.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "control_x2C__management",
    transform: "translate(-1.204 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(4.424 3.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(10.844 5.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536",
    transform: "translate(0 48.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M7.776,26.877a1.1,1.1,0,0,1,1.543-.243h0a1.1,1.1,0,0,1,.243,1.543h0a1.1,1.1,0,0,1-1.541.243h0a1.1,1.1,0,0,1-.245-1.543Z",
    transform: "translate(-7.565 -26.422)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538",
    transform: "translate(35.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M23.647,5.033a1.1,1.1,0,0,1,1.541-.243h0a1.1,1.1,0,0,1,.245,1.543h0a1.1,1.1,0,0,1-1.543.243h0a1.106,1.106,0,0,1-.243-1.543Z",
    transform: "translate(-23.436 -4.579)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544",
    transform: "translate(0.002 20.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(0 18.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M3.424,19.726a1.106,1.106,0,0,1,1.393.71h0a1.107,1.107,0,0,1-.71,1.393h0a1.105,1.105,0,0,1-1.391-.71h0a1.1,1.1,0,0,1,.708-1.393Z",
    transform: "translate(-2.661 -19.672)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    transform: "translate(56.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M29.105,11.383a1.105,1.105,0,0,1,1.391.71h0a1.105,1.105,0,0,1-.708,1.393h0a1.106,1.106,0,0,1-1.393-.71h0a1.1,1.1,0,0,1,.71-1.393Z",
    transform: "translate(-28.34 -11.329)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(0 20.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9036",
    "data-name": "Path 9036",
    d: "M4.108,11.383a1.106,1.106,0,0,1,.708,1.393h0a1.106,1.106,0,0,1-1.393.71h0a1.1,1.1,0,0,1-.708-1.393h0a1.107,1.107,0,0,1,1.393-.71Z",
    transform: "translate(-2.66 -11.328)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548",
    transform: "translate(56.778 18.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M29.787,19.726a1.1,1.1,0,0,1,.708,1.393h0a1.106,1.106,0,0,1-1.393.71h0a1.106,1.106,0,0,1-.708-1.393h0a1.107,1.107,0,0,1,1.393-.71Z",
    transform: "translate(-28.339 -19.672)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554",
    transform: "translate(10.845 5.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9038",
    "data-name": "Path 9038",
    d: "M9.566,5.033a1.108,1.108,0,0,1-.245,1.543h0a1.106,1.106,0,0,1-1.546-.243h0a1.106,1.106,0,0,1,.245-1.543h0a1.11,1.11,0,0,1,1.546.243Z",
    transform: "translate(-7.565 -4.579)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(35.093 48.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9039",
    "data-name": "Path 9039",
    d: "M25.434,26.877a1.106,1.106,0,0,1-.245,1.543h0a1.108,1.108,0,0,1-1.543-.243h0a1.108,1.108,0,0,1,.245-1.543h0a1.1,1.1,0,0,1,1.543.243Z",
    transform: "translate(-23.436 -26.422)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(28.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9040",
    "data-name": "Path 9040",
    d: "M17.711,3.106a1.109,1.109,0,0,1-1.106,1.106h0A1.109,1.109,0,0,1,15.5,3.106h0A1.109,1.109,0,0,1,16.606,2h0a1.109,1.109,0,0,1,1.106,1.106Z",
    transform: "translate(-15.5 -2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(0 59.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9041",
    "data-name": "Path 9041",
    d: "M17.711,30.106a1.109,1.109,0,0,1-1.106,1.106h0A1.109,1.109,0,0,1,15.5,30.106h0A1.109,1.109,0,0,1,16.606,29h0a1.109,1.109,0,0,1,1.106,1.106Z",
    transform: "translate(-15.5 -29)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9042",
    "data-name": "Path 9042",
    d: "M20.844,29.689a8.844,8.844,0,1,1,8.844-8.844A8.853,8.853,0,0,1,20.844,29.689Zm0-15.477a6.633,6.633,0,1,0,6.633,6.633A6.641,6.641,0,0,0,20.844,14.211Z",
    transform: "translate(13.075 13.322)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(6.527 5.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9043",
    "data-name": "Path 9043",
    d: "M16.783,18.5,10.9,26.6a17.354,17.354,0,0,0,1.8,1.289l5.886-8.1A7.716,7.716,0,0,1,16.783,18.5Z",
    transform: "translate(5.22 15.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9044",
    "data-name": "Path 9044",
    d: "M8.365,27.794a1.105,1.105,0,1,0,1.787,1.3l2.622-3.608q-.925-.61-1.789-1.3Z",
    transform: "translate(1.889 22.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9045",
    "data-name": "Path 9045",
    d: "M26.166,7.143a1.105,1.105,0,1,0-1.787-1.3L21.757,9.45q.925.61,1.789,1.3Z",
    transform: "translate(18.364 -0.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9046",
    "data-name": "Path 9046",
    d: "M19.426,18.636l5.879-8.095a17.353,17.353,0,0,0-1.8-1.289l-5.886,8.1A7.809,7.809,0,0,1,19.426,18.636Z",
    transform: "translate(13.356 4.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9047",
    "data-name": "Path 9047",
    d: "M4.378,20.144a1.105,1.105,0,1,0,.683,2.1l4.25-1.382c-.259-.688-.489-1.386-.683-2.1Z",
    transform: "translate(-3.612 16.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9048",
    "data-name": "Path 9048",
    d: "M17.768,16.592,8.26,19.683a17.269,17.269,0,0,0,.677,2.1l9.527-3.093A7.573,7.573,0,0,1,17.768,16.592Z",
    transform: "translate(2.018 13.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9049",
    "data-name": "Path 9049",
    d: "M19.821,18.253l9.508-3.091a17.268,17.268,0,0,0-.677-2.1l-9.527,3.093A7.573,7.573,0,0,1,19.821,18.253Z",
    transform: "translate(15.176 9.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9050",
    "data-name": "Path 9050",
    d: "M30.744,13.793a1.105,1.105,0,1,0-.683-2.1l-4.25,1.382c.259.688.489,1.386.683,2.1Z",
    transform: "translate(23.273 7.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9051",
    "data-name": "Path 9051",
    d: "M5.061,11.692a1.106,1.106,0,1,0-.685,2.1l4.252,1.382a21.852,21.852,0,0,1,.683-2.1Z",
    transform: "translate(-3.611 7.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9052",
    "data-name": "Path 9052",
    d: "M18.463,16.152,8.936,13.059a17.554,17.554,0,0,0-.677,2.1l9.508,3.089A7.721,7.721,0,0,1,18.463,16.152Z",
    transform: "translate(2.017 9.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9053",
    "data-name": "Path 9053",
    d: "M30.746,20.144l-4.252-1.382a21.853,21.853,0,0,1-.683,2.1l4.25,1.38a1.106,1.106,0,1,0,.685-2.1Z",
    transform: "translate(23.273 16.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9054",
    "data-name": "Path 9054",
    d: "M19.126,18.693l9.527,3.093a17.553,17.553,0,0,0,.677-2.1l-9.508-3.089A7.72,7.72,0,0,1,19.126,18.693Z",
    transform: "translate(15.177 13.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    d: "M18.588,17.356,12.7,9.252a18.1,18.1,0,0,0-1.8,1.289l5.881,8.095A7.9,7.9,0,0,1,18.588,17.356Z",
    transform: "translate(5.218 4.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9056",
    "data-name": "Path 9056",
    d: "M10.155,5.845a1.106,1.106,0,1,0-1.791,1.3l2.622,3.608q.862-.693,1.789-1.3Z",
    transform: "translate(1.887 -0.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    d: "M24.378,29.095a1.106,1.106,0,1,0,1.789-1.3l-2.622-3.608q-.862.693-1.789,1.3Z",
    transform: "translate(18.363 22.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    d: "M17.622,19.784l5.888,8.1a18.1,18.1,0,0,0,1.8-1.289L19.426,18.5A7.9,7.9,0,0,1,17.622,19.784Z",
    transform: "translate(13.356 15.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9059",
    "data-name": "Path 9059",
    d: "M17.711,8.583V4.106a1.106,1.106,0,1,0-2.211,0V8.583c.369-.015.732-.055,1.106-.055S17.342,8.567,17.711,8.583Z",
    transform: "translate(10.786 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9060",
    "data-name": "Path 9060",
    d: "M16.606,17.95a7.317,7.317,0,0,1,1.106.113V8.055C17.344,8.033,16.979,8,16.606,8s-.738.033-1.106.055V18.06A7.613,7.613,0,0,1,16.606,17.95Z",
    transform: "translate(10.786 3.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9061",
    "data-name": "Path 9061",
    d: "M15.5,26.475v4.477a1.106,1.106,0,0,0,2.211,0V26.475c-.369.015-.732.055-1.106.055S15.869,26.49,15.5,26.475Z",
    transform: "translate(10.786 25.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9062",
    "data-name": "Path 9062",
    d: "M16.606,19.562a7.317,7.317,0,0,1-1.106-.113V29.454c.367.024.732.057,1.106.057s.738-.033,1.106-.055V19.451A7.613,7.613,0,0,1,16.606,19.562Z",
    transform: "translate(10.786 16.921)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(9.597 9.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9063",
    "data-name": "Path 9063",
    d: "M29.322,53.643a24.336,24.336,0,0,1-23.15-31.8,1.1,1.1,0,0,1,2.1.679A22.1,22.1,0,1,0,19.956,9.287a1.106,1.106,0,1,1-.937-2,24.324,24.324,0,1,1,10.3,46.359Zm0-5.528A18.794,18.794,0,1,1,48.116,29.322,18.815,18.815,0,0,1,29.322,48.116Zm0-35.377A16.583,16.583,0,1,0,45.9,29.322,16.6,16.6,0,0,0,29.322,12.739ZM9.2,18.839a1.092,1.092,0,0,1-.553-.148,1.105,1.105,0,0,1-.4-1.51,24.551,24.551,0,0,1,6.9-7.622,1.106,1.106,0,1,1,1.291,1.8,22.317,22.317,0,0,0-6.277,6.932A1.1,1.1,0,0,1,9.2,18.839Z",
    transform: "translate(-5 -5)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580",
    transform: "translate(44.983 46.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572",
    transform: "translate(5.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9064",
    "data-name": "Path 9064",
    d: "M24.61,39.8a1.106,1.106,0,0,1-.573-2.052A33.5,33.5,0,0,0,37.5,22.177a1.105,1.105,0,1,1,2.039.853A35.714,35.714,0,0,1,25.182,39.638,1.082,1.082,0,0,1,24.61,39.8Z",
    transform: "translate(-23.504 -21.499)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(0 18.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9065",
    "data-name": "Path 9065",
    d: "M23.215,31.106a1.109,1.109,0,0,1-1.106,1.106h0A1.109,1.109,0,0,1,21,31.106h0A1.109,1.109,0,0,1,22.11,30h0a1.109,1.109,0,0,1,1.106,1.106Z",
    transform: "translate(-21.004 -30)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(1.204 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(0 2.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    d: "M2.31,20.528a1.115,1.115,0,0,1-.427-.086A1.1,1.1,0,0,1,1.29,19,35.717,35.717,0,0,1,15.667,2.378,1.106,1.106,0,0,1,16.812,4.27,33.5,33.5,0,0,0,3.329,19.852,1.105,1.105,0,0,1,2.31,20.528Z",
    transform: "translate(-1.204 -2.219)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592",
    transform: "translate(19.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    d: "M12.215,2.106A1.109,1.109,0,0,1,11.11,3.211h0A1.109,1.109,0,0,1,10,2.106h0A1.109,1.109,0,0,1,11.11,1h0a1.109,1.109,0,0,1,1.106,1.106Z",
    transform: "translate(-10.004 -1)"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainenceIcon);
export default __webpack_public_path__ + "static/media/maintainence-icon.c57128d8447aefc5959a057d8e769be2.svg";
export { ForwardRef as ReactComponent };